import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { Card as UIKitCard } from '@beef/ui-kit';

import styles from './styles.pcss';

const cn = classNames.bind(styles);

export const Card = ({
  size = 'm',
  color = 'light-grey',
  className,
  withHover,
  children,
  testName,
}) => (
  <UIKitCard
    className={cn('container', {
      [className]: !!className,
      [`container--${size}`]: !!size,
      [`container--${color}`]: !!color,
    })}
    testName={testName}
    withHover={withHover}
  >
    {children}
  </UIKitCard>
);

Card.propTypes = {
  size: PropTypes.string,
  color: PropTypes.oneOf(['light-grey']),
  className: PropTypes.string,
  testName: PropTypes.string,
  withHover: PropTypes.bool,
  children: PropTypes.node,
};
